module.exports = __webpack_public_path__ + "img/admin.94da34a7.png";